<template>
    <!--
        Opt out of autofill — password managers often set .value without dispatching
        an input event, which leaves app.value out of sync with what the user sees.
          autocomplete="off"     native browser autofill
          data-1p-ignore         1Password
          data-lpignore          LastPass
          data-bwignore          Bitwarden
          data-form-type="other" Dashlane + generic opt-out hint
    -->
    <input
        class="form-control"
        autocomplete="off"
        data-1p-ignore
        data-lpignore="true"
        data-bwignore="true"
        data-form-type="other"
        @input="onInput"
        :minlength="minlength"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :type="type"
        :value="value"
        :name="name"
        :id="name"
    />
</template>
<script setup>
const props = defineProps({
    minlength: { type: [Number, String], default: undefined },
    maxlength: { type: [Number, String], default: undefined },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    value: { type: [String, Number], default: '' },
    name: { type: String, required: true },
    label: { type: String, default: '' },
    // what the field keeps of what is typed, e.g. the digits of "(514) 111-5555" (input-formats.js)
    normalize: { type: Function, default: null },
});
const emit = defineEmits(["update:model-value", "input"]);

function onInput(event) {
    const input = event.target;
    const typed = input.value;
    const kept = props.normalize ? props.normalize(typed) : typed;

    // Rewrite the box directly: when the kept value doesn't change (a "-" typed after "514"), the
    // parent has nothing new to render and the "-" would stay on screen.
    if (kept !== typed) {
        const caretAt = input.selectionStart ?? typed.length;
        // after the same characters it was after, not thrown to the end by a dropped "("
        const caret = Math.min(props.normalize(typed.slice(0, caretAt)).length, kept.length);
        input.value = kept;
        input.setSelectionRange?.(caret, caret);
    }

    emit('input', kept);
}
</script>
